document.addEventListener("DOMContentLoaded", () => {
  const articles = [...document.querySelectorAll(".blog-articles__article.article")];
  
  // console.log(articles);
  articles.forEach((article) => {
    article.addEventListener( "mouseup", function(e) {
      let isOpen = this.getAttribute("data-collapse");
      articles.forEach((element) => element.setAttribute("data-collapse", "close"));

      isOpen == "open" ? this.setAttribute("data-collapse", "close") : this.setAttribute("data-collapse", "open");
    });  
  })
})
